import { TApplicationState } from '../types/redux';

export const selectRegionsList = (state: TApplicationState) => state.form.regionsList;
